import { useCallback, useState } from "react";
import { toast } from "sonner";
import { saveFilter } from "../api/ToursApi";
import { DEFAULT_FILTERS } from "../constants/filters";
import type { ToursFiltersState } from "../types/filters";

// Долгосрочный фильтр редактируется на /tours. Форма стартует с дефолтных значений,
// а сохранение запускает поиск (POST /search), который крон подхватывает как
// повторяющийся фильтр.
export function useToursFilter() {
  const [filters, setFilters] = useState<ToursFiltersState>(DEFAULT_FILTERS);
  const [isSaving, setIsSaving] = useState(false);

  const save = useCallback(async () => {
    setIsSaving(true);
    try {
      await saveFilter(filters);
      toast.success("Фильтр сохранён, поиск запущен");
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Не удалось сохранить фильтр"
      );
      throw error;
    } finally {
      setIsSaving(false);
    }
  }, [filters]);

  return { filters, setFilters, save, isSaving };
}
